import script from "./AssessmentCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssessmentCard.vue?vue&type=script&setup=true&lang=ts"

import "./AssessmentCard.vue?vue&type=style&index=0&id=9b2bc43a&lang=scss&scoped=true"
import "./AssessmentCard.vue?vue&type=style&index=1&id=9b2bc43a&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b2bc43a"]])

export default __exports__